import React from 'react';
import { connect } from 'react-redux';
import { setRevenue } from '../actions/actions';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { setActiveTab } from '../actions/actions';
import { Typography, Container, OutlinedInput } from '@material-ui/core';
import NumberFormat from 'react-number-format';

const ContentArea = styled.div`
  display: grid;
  grid-template-rows: auto auto auto;
  margin: 16px;
  @media (min-width: 801px) {
    border-right: 1px solid #8080803d;
  };
`

const NextButton = styled(Button)`
  width: auto;
  max-width: 800px;
  justify-self: end;
  align-self: center;
  grid-column-start: 2;
  margin-right: 28px !important;
  @media (max-width: 768px) {
    span {
      display: none;
    }
    :after {
      content: '>';
      font-size: 16px;
    }
  }
`

const NavArea = styled.div`
display: grid;
grid-template-columns: auto auto;
`;

const TabTitle = styled(Typography)`
  place-self: center
`;

const ResponsiveContainer = styled(Container)`
  margin: 12px;
`

const MCInput = styled(OutlinedInput)`
  margin-top: 16px;
`



function TabContent(props) {
  const handleFocus = (event) => event.target.select();
  const handleChange = (values) => {
    props.setRevenue(values.value)
  }

  return (
    <ContentArea>
      <TabTitle variant="h4">Faturamento</TabTitle>
      <ResponsiveContainer>
        <Typography variant="subtitle1">Informe seu faturamento mensal estimado: </Typography>
        <NumberFormat value={props.financialSetup.revenue} customInput={MCInput} displayType={'input'} thousandSeparator={'.'} decimalSeparator={','} isNumericString={true} onFocus={handleFocus} onValueChange={handleChange} prefix={'R$'} />
      </ResponsiveContainer>
      <ResponsiveContainer>
        <Typography variant="h6">Ajuda</Typography>
        <Typography variant="body">Informe o <b>faturamento mensal previsto</b> para o negócio. Caso já tenha o histórico, informe em um cenário mais realista possível. Caso ainda não tenha o histórico, não se preocupe, crie quantos cenários desejar.
          </Typography>
      </ResponsiveContainer>
      <NavArea>
        <NextButton
          variant="contained"
          onClick={() => props.setActiveTab(props.activeTab + 1)}
          color="secondary"
          disabled={props.financialSetup.revenue <= 0}
          endIcon={<NavigateNextIcon />}
        >
          Próximo
        </NextButton>
      </NavArea>
    </ContentArea>
  );
}

const mapStateToProps = (state) => {
  return {
    financialSetup: state.reducers.financialSetup,
    activeTab: state.reducers.activeTab
  }
}

const mapDispatchToProps = { setRevenue, setActiveTab }
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabContent)

